<template>
  <div>
    <navbarBox />
    <showusercomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import showusercomponents from "@/components/showusercomponents.vue";
export default {
  components: { showusercomponents, navbarBox },
};
</script>
